import React, { useEffect, useState } from 'react';
import { PlusOutlined } from '@ant-design/icons';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import {
  Button,
  Checkbox,
  Col,
  Collapse,
  CollapseProps,
  DatePicker,
  Divider,
  Form,
  Input,
  InputNumber,
  Modal,
  Radio,
  Row,
  Select,
  Spin,
  notification,
} from 'antd';
import TextArea from 'antd/es/input/TextArea';
import Title from 'antd/es/typography/Title';
import { APP_LOCAL_DATE_FORMAT, APP_LOCAL_DATE_FORMAT_PAYLOAD } from 'app/config/constants';
import {
  getAssociates,
  getDivergenceEntities,
  getFrequencyType,
  getKrTrendingQuantitativeTypes,
  getKrTypes,
  getQualityEvaluationTypes,
  getQuantitativeEvaluationTypes,
} from 'app/entities/common/common.reducer';
import { getOnlyPersonInOrg as getEmployees } from 'app/entities/common/common.reducer';
import ObjectiveUpdate from 'app/entities/objective/form/objective-update';
import { getEntities as getPlanPeriods } from 'app/entities/plan-period/plan-period.reducer';
import DatePickerCustomValidate from 'app/shared/component/DatePickerCUstom/DatePickerCustomValidate';
import { KrTypes } from 'app/shared/model/enum/kr.enum';
import { QuantitativeEvaluationType } from 'app/shared/model/enum/quantitativeEvaluation.enum';
import { TrendingTypes } from 'app/shared/model/enum/trending.enum';
import { formatNumber, parseNumber } from 'app/shared/util/help';
import { displayPercent, percent } from 'app/shared/util/percent';
import { filterOption } from 'app/shared/util/select-filter';
import dayjs from 'dayjs';
import * as _ from 'lodash';
import { useParams } from 'react-router-dom';
import { Container } from 'reactstrap';
import { getInfo } from '../../objective/objective.reducer';
import {
  createKrQual,
  createEntity as createQualitative,
  getEntity as getQualitative,
  reset as resetQualitative,
  updateEntity as updateQualitative,
} from '../kr-qualitative.reducer';
import {
  createKrQuanti,
  createEntity as createQuantitative,
  getEntity as getQuantitative,
  reset as resetQuantitative,
  updateEntity as updateQuantitative,
} from '../kr-quantitative.reducer';
import { PlantPeriodType } from 'app/shared/model/enum/plantPeriod.enum';
import { ObjectiveKRRowSelection } from 'app/entities/activities/form/view-row-selection/objective-kr';

type KrFormType = {
  isOpen: boolean;
  onClose: (isReload?: boolean) => void;
  idObjective?: string;
  planPeriodIdSelected?: string;
  idKrBaseSelected?: string;
  krTypeRequest?: number;
  planPeriodType?: PlantPeriodType;
  isReadOnly?: boolean
};

export const KRUpdate = ({ isOpen, onClose, planPeriodIdSelected, idObjective, idKrBaseSelected, krTypeRequest, planPeriodType, isReadOnly }: KrFormType) => {
  const dispatch = useAppDispatch();
  const [form] = Form.useForm();
  const isNew = idKrBaseSelected === undefined || idKrBaseSelected === null;
  const { id } = useParams();

  const krQualitativeEntity = useAppSelector(state => state.krQualitative.entity);
  const krQuantitativeEntity = useAppSelector(state => state.krQuantitative.entity);
  const objectiveEntity = useAppSelector(state => state.objective.entity);
  const planPeriodList = useAppSelector(state => state.planPeriod.entities);
  const updating = useAppSelector(state => state.kr.updating);
  const krQualitativeUpdateSuccess = useAppSelector(state => state.krQualitative.updateSuccess);
  const krQuantitativeUpdateSuccess = useAppSelector(state => state.krQuantitative.updateSuccess);
  const loadingQualitative = useAppSelector(state => state.krQualitative.loading);
  const loadingQuantitative = useAppSelector(state => state.krQuantitative.loading);

  // common data
  const employeeList = useAppSelector(state => state.common.personPositions);
  const frequencies = useAppSelector(state => state.common.frequencies);
  const qualityEvaluationTypes = useAppSelector(state => state.common.qualityType);
  const krTypes = useAppSelector(state => state.common.krType);
  const krTrendingTypes = useAppSelector(state => state.common.krTrending);
  const quantitativeTypes = useAppSelector(state => state.common.quantitative);
  const associateTypes = useAppSelector(state => state.common.associates);
  const lesserPlanPeriodTypes = useAppSelector(state => state.common.lesserPlanPeriod);

  const [planPeriodSelected, setPlanPeriodSelected] = useState<any>();
  const [isOpenModalFormObjective, setIsOpenModalFormObjective] = useState(false);
  const [lesserPlanPeriod, setLesserPlanPeriod] = useState([]);
  const [isOpenModal, setOpenModal] = useState(false);
  const [isSaveChange, setSaveChange] = useState(false);

  // define values for max, min dates
  const [mintDate, setMinDate] = useState();
  const [maxDate, setMaxDate] = useState();

  // form watcher data

  const krTypeValues = Form.useWatch('krType', form);
  const metricTypeValues = Form.useWatch('metricType', form);
  const planPeriodIdValues = Form.useWatch('planPeriodId', form);
  const evaluationMethodQuantitativeValue = Form.useWatch('evaluationMethodQuantitative', form);

  const metricValueYearValues = Form.useWatch('metricValue', form);
  const metricValueFirstValues = Form.useWatch('metricValue-0', form);
  const metricValueSecondValues = Form.useWatch('metricValue-1', form);
  const metricValueThirdValues = Form.useWatch('metricValue-2', form);
  const metricValueFourthValues = Form.useWatch('metricValue-3', form);

  // define data collapse
  const items: CollapseProps['items'] = [
    {
      key: '1',
      label: 'Thông tin mục tiêu',
      children: (
        <Row>
          <Col md={7}>
            <Form.Item label="Lĩnh vực">
              <Input className="w-100" value={objectiveEntity?.fieldName} disabled size="large" />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={7}>
            <Form.Item label="Dự án">
              <Input className="w-100" value={objectiveEntity?.name} disabled size="large" />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={8}>
            <Form.Item label="Nhóm công việc">
              <Input className="w-100" value={objectiveEntity?.workTypeName} disabled size="large" />
            </Form.Item>
          </Col>
          <Col md={24}>
            <Form.Item label="Nội dung mục tiêu">
              <TextArea disabled value={objectiveEntity?.purpose} placeholder="Nhập nội dung mục tiêu" size="large" />
            </Form.Item>
          </Col>
          <span className="cursor-pointer text-primary" onClick={() => handleEditObjective()}>
            {`Thông tin chi tiết >`}
          </span>
        </Row>
      ),
    },
  ];

  const handleClose = (isReload = undefined) => {
    form.resetFields();
    dispatch(resetQualitative());
    dispatch(resetQuantitative());
    onClose(isReload ?? isSaveChange);
  };

  useEffect(() => {
    innitData();
  }, [isOpen]);

  useEffect(() => {
    setLesserPlanPeriod(lesserPlanPeriodTypes);
  }, [lesserPlanPeriodTypes]);

  useEffect(() => {
    if (krQualitativeUpdateSuccess || krQuantitativeUpdateSuccess) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-enum-comparison
      if (krTypeRequest === KrTypes.Qualitative) {
        handleClose(krQualitativeUpdateSuccess);
      }
      else {
        handleClose(krQuantitativeUpdateSuccess);
      }
    }
  }, [krQualitativeUpdateSuccess, krQuantitativeUpdateSuccess]);

  useEffect(() => {
    if (lesserPlanPeriod && lesserPlanPeriod.length > 0 && krTypeValues === KrTypes.AccumulateQuantitative) {
      if (lesserPlanPeriod.length > 3) {
        const value = (metricValueYearValues ?? 0) - ((metricValueFirstValues ?? 0) + (metricValueSecondValues ?? 0) + (metricValueThirdValues ?? 0))
        if (_.isInteger(value))
          form.setFieldValue(`metricValue-${lesserPlanPeriod.length - 1}`, (value ?? 0))
        else
          form.setFieldValue(`metricValue-${lesserPlanPeriod.length - 1}`, value.toFixed(2))
      }
      else {
        const value = (metricValueYearValues ?? 0) - ((metricValueFirstValues ?? 0) + (metricValueSecondValues ?? 0))
        if (_.isInteger(value))
          form.setFieldValue(`metricValue-${lesserPlanPeriod.length - 1}`, (value ?? 0))
        else form.setFieldValue(`metricValue-${lesserPlanPeriod.length - 1}`, value.toFixed(2))
      }
    }
  }, [metricValueYearValues, metricValueFirstValues, metricValueSecondValues, metricValueThirdValues])

  useEffect(() => {
    if (krTypeValues !== KrTypes.Qualitative) {
      dispatch(getQuantitativeEvaluationTypes());
      dispatch(getKrTrendingQuantitativeTypes());
    }
  }, [krTypeValues]);

  useEffect(() => {
    if (planPeriodIdValues) {
      handleChangePlanPeriod(planPeriodIdValues);
    }
  }, [planPeriodIdValues]);

  useEffect(() => {
    if (evaluationMethodQuantitativeValue !== QuantitativeEvaluationType.SelfDefinition && metricTypeValues >= 0) {
      if (metricTypeValues === TrendingTypes.Above) {
        form.setFieldValue('evaluationMethodQuantitativeNote', 'Giá trị thực hiện / Giá trị cần đạt được');
      } else {
        form.setFieldValue('evaluationMethodQuantitativeNote', 'Giá trị cần đạt được / Giá trị thực hiện');
      }
    } else {
      form.setFieldValue('evaluationMethodQuantitativeNote', krQuantitativeEntity?.evaluationMethodQuantitativeNote ?? '');
    }
  }, [metricTypeValues, evaluationMethodQuantitativeValue])

  useEffect(() => {
    if ((krQualitativeEntity || krQuantitativeEntity) && !isNew) {
      let entityCommon;
      const objectData = {};
      // eslint-disable-next-line @typescript-eslint/no-unsafe-enum-comparison
      if (krTypeRequest === KrTypes.Qualitative && krQualitativeEntity) {
        entityCommon = { ...krQualitativeEntity };
        // Create a new array without the item at the specified index
        const newSub = krQualitativeEntity?.subs?.map((x: any) => {
          if (x) {
            return {
              startDate: x.startDate,
              dueDate: x.dueDate,
              purpose: x.purpose,
            };
          }
        });
        newSub?.forEach((item, index) => {
          if (item) {
            Object.entries(item).forEach(([key, value]: any) => {
              if (key === 'startDate' || key === 'dueDate') {
                objectData[`${index !== 0 ? `${key}-${index - 1}` : key}`] = dayjs(value);
              } else {
                objectData[`${index !== 0 ? `${key}-${index - 1}` : key}`] = value;
              }
            });
          }
        });
      } else {
        entityCommon = { ...krQuantitativeEntity };
        // Create a new array without the item at the specified index
        const newSub = krQuantitativeEntity?.subs?.map((x: any) => {
          if (x) {
            return {
              startDate: x.startDate,
              dueDate: x.dueDate,
              metricValue: x.metricValue,
            };
          }
        });
        newSub?.forEach((item, index) => {
          if (item) {
            Object.entries(item).forEach(([key, value]: any) => {
              if (key === 'startDate' || key === 'dueDate') {
                objectData[`${index !== 0 ? `${key}-${index - 1}` : key}`] = dayjs(value);
              } else {
                objectData[`${index !== 0 ? `${key}-${index - 1}` : key}`] = value;
              }
            });
          }
        });
      }
      const entity = {
        ...entityCommon,
        tags: _.join(entityCommon.tags, ','),
        startDate: dayjs(entityCommon.startDate),
        dueDate: dayjs(entityCommon.dueDate),
        informEmails: entityCommon.raci?.informEmails,
        consultantIds: entityCommon.raci?.consultantIds,
        accountableId: entityCommon.raci?.accountableId,
        responsibleIds: entityCommon.raci?.responsibleIds,
        contribution: entityCommon.contribution && displayPercent(krQualitativeEntity.contribution),
        ...objectData,
      };
      form.setFieldsValue(entity);
      // const planPeriodId = krQualitativeEntity.planPeriodId || krQuantitativeEntity.planPeriodId;
      // if (planPeriodId) {
      //   handleChangePlanPeriod(planPeriodId);
      // }
    }
  }, [krQualitativeEntity, krQuantitativeEntity]);

  const innitData = () => {
    // get detail
    dispatch(getAssociates());
    dispatch(getEmployees());
    dispatch(getQualityEvaluationTypes());
    dispatch(getKrTypes());
    dispatch(getPlanPeriods({}));
    dispatch(getInfo(id ?? idObjective));
    if (isNew) {
      form.resetFields();
    } else {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-enum-comparison
      if (krTypeRequest === KrTypes.Qualitative) dispatch(getQualitative({ idKrBaseSelected, planPeriodId: planPeriodIdSelected || krQualitativeEntity.planPeriodId }));
      else dispatch(getQuantitative({ idKrBaseSelected, planPeriodId: planPeriodIdSelected || krQualitativeEntity.planPeriodId }));
    }
  };

  const handleValidateQuarter = quarter => {
    const check = _.every(quarter, o => {
      return !o.purpose || !o.startDate || !o.dueDate;
    });
    if (check) {
      notification.warning({ message: 'Vui lòng nhập ít nhất 1 trong 4 quý', placement: 'topLeft' });
      return false;
    }
    return true;
  };

  // const handleChangeEvaluationMethod = e => {
  //   if (e.target.value !== QuantitativeEvaluationType.SelfDefinition && metricTypeValues >= 0) {
  //     if (metricTypeValues === TrendingTypes.Above) {
  //       form.setFieldValue('evaluationMethodQuantitativeNote', 'Giá trị thực hiện / Giá trị cần đạt được');
  //     } else {
  //       form.setFieldValue('evaluationMethodQuantitativeNote', 'Giá trị cần đạt được / Giá trị thực hiện');
  //     }
  //   } else {
  //     form.setFieldValue('evaluationMethodQuantitativeNote', '');
  //   }
  // }

  // eslint-disable-next-line complexity
  const handleSubmit = values => {
    const {
      tags,
      contribution,
      informEmails,
      consultantIds,
      accountableId,
      responsibleIds,
      associateIds,
      evaluationMethods,
      krType,
      planPeriodId,
      frequencyId,
      accessIds,
      sendingNotification,
      ...remainingValues
    } = values;
    let subs = [];
    if (krTypeValues === KrTypes.Qualitative) {
      // Khởi tạo mảng khóa
      const keys = Object.keys(remainingValues);
      // Chia mảng thành các nhóm nhỏ, mỗi nhóm có 3 phần tử
      const groupedKeys = _.chunk(keys, 3);
      // Tạo mảng mới từ các nhóm khóa
      subs = _.map(groupedKeys, group => {
        const mapper = _.map(group, key => {
          if (key.includes('startDate') || key.includes('dueDate')) {
            return dayjs(remainingValues[key]).format(APP_LOCAL_DATE_FORMAT_PAYLOAD); // Định dạng ngày theo ý muốn
          }
          return remainingValues[key];
        });
        return _.zipObject(['purpose', 'startDate', 'dueDate'], mapper);
      });

      const quarter = _.filter(subs, (o, index) => {
        return index !== 0;
      });

      if (!handleValidateQuarter(quarter)) return;

      subs = subs.map((item, index) => {
        return {
          ...item,
          planPeriodId: index !== 0 ? lesserPlanPeriod[index - 1].id : planPeriodId,
          purpose: item.purpose !== undefined && item.purpose != null ? item.purpose : ""
        };
      });
      const detailEntity = !isNew ? krQualitativeEntity : undefined;
      const combinedSubs =
        detailEntity?.subs.length > 0
          ? subs.map((item, index) => {
            return {
              ...item,
              id: detailEntity.subs[index] && detailEntity.subs[index].id,
            };
          })
          : subs;
      // combinedSubs = _.filter(combinedSubs, o => {
      //   return o.purpose && dayjs(o.startDate).isValid() && dayjs(o.dueDate).isValid();
      // });
      const entity = {
        ...detailEntity,
        evaluationMethods,
        krType,
        accessIds,
        planPeriodId,
        frequencyId,
        sendingNotification,
        associateIds: associateIds ?? [],
        tags: _.split(tags, ','),
        contribution: percent(contribution),
        objectiveId: id ?? idObjective,
        raci: {
          informEmails: _.split(informEmails, ','),
          consultantIds,
          accountableId,
          responsibleIds,
        },
        subs: combinedSubs,
      };
      if (isNew) {
        dispatch(createQualitative(entity));
      } else {
        dispatch(updateQualitative(entity));
      }
    } else {
      const {
        evaluationMethodQuantitative,
        evaluationMethodQuantitativeNote,
        name,
        unit,
        startDate,
        dueDate,
        metricType,
        ...remainingQuantitativeValues
      } = remainingValues;
      // Khởi tạo mảng khóa
      const keys = Object.keys(remainingQuantitativeValues);

      // Chia mảng thành các nhóm nhỏ, mỗi nhóm có 3 phần tử
      const groupedKeys = _.chunk(keys, 1);
      subs = _.map(groupedKeys, group => {
        const mapper = _.map(group, key => {
          return remainingQuantitativeValues[key];
        });
        return _.zipObject(['metricValue'], mapper);
      });
      const detailEntity = !isNew ? krQuantitativeEntity : undefined;
      subs = subs.map((item, index) => {
        return {
          ...item,
          metricValue: item.metricValue !== 0 ? item.metricValue : 0,
          planPeriodId: index !== 0 ? lesserPlanPeriod[index - 1].id : planPeriodId,
          startDate:
            index !== 0
              ? dayjs(lesserPlanPeriod[index - 1].startDate).format(APP_LOCAL_DATE_FORMAT_PAYLOAD)
              : dayjs(startDate).format(APP_LOCAL_DATE_FORMAT_PAYLOAD),
          dueDate:
            index !== 0
              ? dayjs(lesserPlanPeriod[index - 1].dueDate).format(APP_LOCAL_DATE_FORMAT_PAYLOAD)
              : dayjs(dueDate).format(APP_LOCAL_DATE_FORMAT_PAYLOAD),
        };
      });
      let combinedSubs =
        detailEntity?.subs.length > 0
          ? subs.map((item, index) => {
            return { ...item, id: detailEntity.subs[index] && detailEntity.subs[index].id };
          })
          : subs;
      combinedSubs = combinedSubs.map(x => {
        return { ...x, metricValue: x.metricValue !== null && x.metricValue !== undefined ? x.metricValue : 0 }
      })
      const entity = {
        ...detailEntity,
        evaluationMethodQuantitative,
        evaluationMethodQuantitativeNote,
        krType,
        name,
        unit,
        metricType,
        startDate: dayjs(startDate).format(APP_LOCAL_DATE_FORMAT_PAYLOAD),
        dueDate: dayjs(dueDate).format(APP_LOCAL_DATE_FORMAT_PAYLOAD),
        accessIds,
        planPeriodId,
        frequencyId,
        sendingNotification,
        associateIds: associateIds ?? [],
        tags: _.split(tags, ','),
        contribution: percent(contribution),
        objectiveId: id ?? idObjective,
        raci: {
          informEmails: _.split(informEmails, ','),
          consultantIds,
          accountableId,
          responsibleIds,
        },
        subs: combinedSubs,
      };
      if (isNew) {
        dispatch(createQuantitative(entity));
      } else {
        dispatch(updateQuantitative(entity));
      }
    }
  };

  const handleChangePlanPeriod = (planPeriod: string) => {
    dispatch(getFrequencyType(planPeriod));
    handleLesserPlanPeriod(planPeriod);
    const planPeriodDetails = _.find(planPeriodList, o => o.id === planPeriod);
    if (planPeriodDetails) {
      if (isNew) {
        form.setFieldValue('startDate', dayjs(planPeriodDetails.startDate));
        form.setFieldValue('dueDate', dayjs(planPeriodDetails.endDate));
      }
      setPlanPeriodSelected(planPeriodDetails);
      setMinDate(planPeriodDetails.startDate);
      setMaxDate(planPeriodDetails.endDate);
    }
  };

  const handleMapperResultByPlanPeriod = () => {
    if (lesserPlanPeriod && lesserPlanPeriod.length > 0) {
      return lesserPlanPeriod.map((item, index) => {
        if (krTypeValues === KrTypes.Qualitative) {
          form.setFieldValue(`startDate-${index}`, dayjs(item.startDate));
          form.setFieldValue(`dueDate-${index}`, dayjs(item.endDate));
          return (
            <Row key={item.id}>
              <Col className="d-flex" md={2}>
                <span className="mt-2 fw-bold">{item.name}</span>
              </Col>
              <Col md={13}>
                <Form.Item name={`purpose-${index}`}>
                  <TextArea rows={1} placeholder={`Nhập kết quả cần đạt ${item.name}`} size="large" />
                </Form.Item>
              </Col>
              <Col md={1} />
              <Col md={3}>
                <DatePickerCustomValidate
                  form={form}
                  index={index}
                  item={item}
                  messageRequired={'Hãy chọn ngày bắt đầu'}
                  name={`startDate-${index}`}
                  placeholder="Chọn ngày bắt đầu"
                  initialValue={dayjs(item.startDate)}
                />
              </Col>
              <Col md={1} />
              <Col md={4}>
                <DatePickerCustomValidate
                  form={form}
                  index={index}
                  item={item}
                  messageRequired={'Hãy chọn thời hạn hoàn thành'}
                  name={`dueDate-${index}`}
                  placeholder="Chọn thời hạn hoàn thành"
                  initialValue={dayjs(item.endDate)}
                />
              </Col>
            </Row>
          );
        } else
          return (
            <>
              <Col md={3}>
                <Form.Item rules={[
                  krTypes === KrTypes.AccumulateQuantitative ? {
                    type: 'number', max: (index === (lesserPlanPeriod.length - 1)) ?
                      lesserPlanPeriod.length > 3 ?
                        (metricValueYearValues ?? 0) - ((metricValueFirstValues ?? 0) + (metricValueSecondValues ?? 0) + (metricValueThirdValues ?? 0)) :
                        (metricValueYearValues ?? 0) - ((metricValueFirstValues ?? 0) + (metricValueSecondValues ?? 0)) :
                      undefined,
                    message: "Giá trị không hợp lệ"
                  } : undefined
                ]} label={`Chỉ tiêu ${item.name}`} name={`metricValue-${index}`}>
                  <InputNumber step={0.01} precision={2} className='w-100' formatter={formatNumber} parser={parseNumber} placeholder={`Nhập chỉ tiêu quý ${item.name}`} size="large" />
                </Form.Item>
              </Col>
              <Col md={1} />
            </>
          );
      });
    }
  };

  const handleEditObjective = () => {
    setIsOpenModalFormObjective(true);
  };

  const handleCloseModelObjective = (isReload = false) => {
    setIsOpenModalFormObjective(false);
  };

  const handleLesserPlanPeriod = async (planPeriodId: string) => {
    await dispatch(getDivergenceEntities(planPeriodId));
  };

  const handleNextKr = () => {
    form
      .validateFields()
      .then(values => {
        const {
          tags,
          contribution,
          informEmails,
          consultantIds,
          accountableId,
          responsibleIds,
          associateIds,
          evaluationMethods,
          krType,
          planPeriodId,
          frequencyId,
          accessIds,
          sendingNotification,
          ...remainingValues
        } = values;
        let subs = [];
        if (krTypeValues === KrTypes.Qualitative) {
          // Khởi tạo mảng khóa
          const keys = Object.keys(remainingValues);
          // Chia mảng thành các nhóm nhỏ, mỗi nhóm có 3 phần tử
          const groupedKeys = _.chunk(keys, 3);
          // Tạo mảng mới từ các nhóm khóa
          subs = _.map(groupedKeys, group => {
            const mapper = _.map(group, key => {
              if (key.includes('startDate') || key.includes('dueDate')) {
                return dayjs(remainingValues[key]).format(APP_LOCAL_DATE_FORMAT_PAYLOAD); // Định dạng ngày theo ý muốn
              }
              return remainingValues[key];
            });
            return _.zipObject(['purpose', 'startDate', 'dueDate'], mapper);
          });

          const quarter = _.filter(subs, (o, index) => {
            return index !== 0;
          });

          if (!handleValidateQuarter(quarter)) return;

          subs = subs.map((item, index) => {
            return {
              ...item,
              planPeriodId: index !== 0 ? lesserPlanPeriod[index - 1].id : planPeriodId,
            };
          });
          const detailEntity = !isNew ? krQualitativeEntity : undefined;
          const combinedSubs =
            detailEntity?.subs.length > 0
              ? subs.map((item, index) => {
                return {
                  ...item,
                  id: detailEntity.subs[index] && detailEntity.subs[index].id,
                };
              })
              : subs;
          // combinedSubs = _.filter(combinedSubs, o => {
          //   return o.purpose && dayjs(o.startDate).isValid() && dayjs(o.dueDate).isValid();
          // });
          const entity = {
            ...detailEntity,
            evaluationMethods,
            krType,
            accessIds,
            planPeriodId,
            frequencyId,
            sendingNotification,
            associateIds: associateIds ?? [],
            tags: _.split(tags, ','),
            contribution: percent(contribution),
            objectiveId: id ?? idObjective,
            raci: {
              informEmails: _.split(informEmails, ','),
              consultantIds,
              accountableId,
              responsibleIds,
            },
            subs: combinedSubs,
          };
          dispatch(createKrQual(entity))
            .then(res => {
              if (res && res.payload) {
                form.resetFields();
                setSaveChange(true);
              }
            })
            .catch(() => {
              return;
            });
        } else {
          const {
            evaluationMethodQuantitative,
            evaluationMethodQuantitativeNote,
            name,
            unit,
            startDate,
            dueDate,
            metricType,
            ...remainingQuantitativeValues
          } = remainingValues;
          // Khởi tạo mảng khóa
          const keys = Object.keys(remainingQuantitativeValues);

          // Chia mảng thành các nhóm nhỏ, mỗi nhóm có 3 phần tử
          const groupedKeys = _.chunk(keys, 1);
          subs = _.map(groupedKeys, group => {
            const mapper = _.map(group, key => {
              return remainingQuantitativeValues[key];
            });
            return _.zipObject(['metricValue'], mapper);
          });
          const detailEntity = !isNew ? krQuantitativeEntity : undefined;
          subs = subs.map((item, index) => {
            return {
              ...item,
              planPeriodId: index !== 0 ? lesserPlanPeriod[index - 1].id : planPeriodId,
              startDate:
                index !== 0
                  ? dayjs(lesserPlanPeriod[index - 1].startDate).format(APP_LOCAL_DATE_FORMAT_PAYLOAD)
                  : dayjs(startDate).format(APP_LOCAL_DATE_FORMAT_PAYLOAD),
              dueDate:
                index !== 0
                  ? dayjs(lesserPlanPeriod[index - 1].dueDate).format(APP_LOCAL_DATE_FORMAT_PAYLOAD)
                  : dayjs(dueDate).format(APP_LOCAL_DATE_FORMAT_PAYLOAD),
            };
          });
          let combinedSubs =
            detailEntity?.subs.length > 0
              ? subs.map((item, index) => {
                return { ...item, id: detailEntity.subs[index] && detailEntity.subs[index].id };
              })
              : subs;
          combinedSubs = combinedSubs.map(x => {
            return { ...x, metricValue: x.metricValue !== null && x.metricValue !== undefined ? x.metricValue : 0 }
          })
          const entity = {
            ...detailEntity,
            evaluationMethodQuantitative,
            evaluationMethodQuantitativeNote,
            krType,
            name,
            unit,
            metricType,
            startDate: dayjs(startDate).format(APP_LOCAL_DATE_FORMAT_PAYLOAD),
            dueDate: dayjs(dueDate).format(APP_LOCAL_DATE_FORMAT_PAYLOAD),
            accessIds,
            planPeriodId,
            frequencyId,
            sendingNotification,
            associateIds: associateIds ?? [],
            tags: _.split(tags, ','),
            contribution: percent(contribution),
            objectiveId: id ?? idObjective,
            raci: {
              informEmails: _.split(informEmails, ','),
              consultantIds,
              accountableId,
              responsibleIds,
            },
            subs: combinedSubs,
          };
          dispatch(createKrQuanti(entity))
            .then(res => {
              if (res && res.payload) {
                form.resetFields();
              }
            })
            .catch(() => {
              return;
            });
        }
      })
      .catch(() => {
        return;
      });
  };

  const handleCloseModal = (isUpdateValue = true, itemSelected = []) => {
    if (isUpdateValue) {
      form.setFieldsValue(
        {
          alignCode: itemSelected.length > 0 ? `${_.join(itemSelected.map(x => x.code), " ,")}` : null,
          associateIds: itemSelected.map(x => x.id)
        }
      );
    }
    setOpenModal(false)
  }

  const handleOpenModalViewRowSelection = () => {
    setOpenModal(true)
  }

  return (
    <Modal
      open={isOpen}
      maskClosable={false}
      onCancel={() => {
        handleClose();
      }}
      footer={null}
      width={1300}
    >
      <Spin delay={300} spinning={loadingQualitative || loadingQuantitative}>
        <Container className="form">
          <Form
            size="large"
            form={form}
            initialValues={{
              sendingNotification: false,
            }}
            onFinish={handleSubmit}
            layout="vertical"
            disabled={isReadOnly}
          >
            <Title level={3}>{`${idKrBaseSelected ? 'Cập nhật thông tin' : 'Thêm mới'} KR`}</Title>

            <Form.Item>
              <Collapse items={items} />
            </Form.Item>
            <Row>
              <Col md={3}>
                <Form.Item
                  label="Kỳ kế hoạch"
                  initialValue={planPeriodIdSelected}
                  rules={[{ required: true, message: 'Hãy chọn kỳ kế hoạch' }]}
                  name="planPeriodId"
                >
                  <Select
                    allowClear
                    showSearch
                    size="large"
                    disabled={!isNew}
                    filterOption={filterOption}
                    options={planPeriodList.map(x => {
                      return {
                        label: x.name,
                        value: x.id,
                      };
                    })}
                    placeholder="Chọn kỳ kế hoạch"
                  />
                </Form.Item>
              </Col>
              <Col md={1} />
              <Col md={14}>
                <Form.Item label="Mục tiêu, KR liên kết" name="associateIds">
                  <Row gutter={8} align="middle">
                    <Col flex="auto">
                      <Form.Item noStyle
                        name={'alignCode'}>
                        <Input
                          readOnly
                          size="large"
                          placeholder="Chọn mục tiêu, KR liên kết"
                        />
                      </Form.Item>
                    </Col>
                    <Col>
                      <Button
                        className="primary"
                        size="large"
                        onClick={handleOpenModalViewRowSelection}
                        icon={<PlusOutlined />}
                      >
                      </Button>
                    </Col>
                  </Row>
                  {/* <Select
                    allowClear
                    showSearch
                    mode="multiple"
                    size="large"
                    disabled={!isNew && planPeriodType === PlantPeriodType.Quarter}
                    filterOption={filterOption}
                    options={associateTypes}
                    placeholder="Chọn mục tiêu, KR liên kết"
                  /> */}
                </Form.Item>
              </Col>
              <Col md={1} />
              <Col md={5}>
                <Form.Item
                  initialValue={KrTypes.Qualitative}
                  label="Loại KR"
                  rules={[{ required: true, message: 'Hãy chọn loại KR' }]}
                  name="krType"
                >
                  <Select filterOption={filterOption} allowClear showSearch size="large"
                    disabled={!isNew && planPeriodType === PlantPeriodType.Quarter} options={krTypes} placeholder="Chọn loại KR" />
                </Form.Item>
              </Col>
            </Row>
            {planPeriodSelected &&
              (krTypeValues === KrTypes.Qualitative ? (
                <>
                  <Row>
                    <Col className="d-flex align-items-center" md={2}>
                      <span className="mt-2 fw-bold">{`${planPeriodSelected ? planPeriodSelected.name : ''}`}</span>
                    </Col>
                    <Col md={13}>
                      <Form.Item
                        label={`Kết quả cần đạt được`}
                        rules={[{ required: true, message: 'Hãy nhập kết quả cần đạt được' }]}
                        name={'purpose'}
                      >
                        <TextArea rows={1} placeholder="Nhập kết quả cần đạt được" size="large"
                          disabled={!isNew && planPeriodType === PlantPeriodType.Quarter} />
                      </Form.Item>
                    </Col>
                    <Col md={1} />
                    <Col md={3}>
                      <Form.Item
                        initialValue={dayjs().startOf('year')}
                        rules={[{ required: true, message: 'Hãy chọn ngày bắt đầu' }]}
                        label="Ngày bắt đầu" name={'startDate'}>
                        <DatePicker
                          minDate={dayjs(mintDate)}
                          maxDate={dayjs(maxDate)}
                          className="w-100"
                          size="large"
                          disabled={!isNew && planPeriodType === PlantPeriodType.Quarter}
                          format={APP_LOCAL_DATE_FORMAT}
                          placeholder="Chọn ngày bắt đầu"
                        />
                      </Form.Item>
                    </Col>
                    <Col md={1} />
                    <Col md={4}>
                      <Form.Item
                        rules={[{ required: true, message: 'Hãy chọn thời hạn hoàn thành' }]}
                        label="Thời hạn hoàn thành"
                        name={'dueDate'}
                        initialValue={dayjs().endOf('year')}
                      >
                        <DatePicker
                          minDate={dayjs(mintDate)}
                          maxDate={dayjs(maxDate)}
                          className="w-100"
                          size="large"
                          disabled={!isNew && planPeriodType === PlantPeriodType.Quarter}
                          format={APP_LOCAL_DATE_FORMAT}
                          placeholder="Chọn thời hạn hoàn thành"
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  {handleMapperResultByPlanPeriod()}
                </>
              ) : (
                <>
                  <Divider orientation="left">Kết quả cần đạt được</Divider>
                  <Row>
                    <Col md={11}>
                      <Form.Item label="Tên chỉ tiêu" rules={[{ required: true, message: 'Hãy nhập Tên chỉ tiêu' }]} name={'name'}>
                        <Input
                          disabled={!isNew && planPeriodType === PlantPeriodType.Quarter} placeholder="Nhập Tên chỉ tiêu" size="large" />
                      </Form.Item>
                    </Col>
                    <Col md={1} />
                    <Col md={3}>
                      <Form.Item label="Đơn vị tính" rules={[{ required: true, message: 'Hãy chọn đơn vị tính' }]} name="unit">
                        <Input
                          disabled={!isNew && planPeriodType === PlantPeriodType.Quarter} placeholder={`Nhập đơn vị tính`} size="large" />
                      </Form.Item>
                    </Col>
                    <Col md={1} />
                    <Col md={3}>
                      <Form.Item label="Ngày bắt đầu" rules={[{ required: true, message: 'Hãy chọn ngày bắt đầu' }]} name={'startDate'}>
                        <DatePicker
                          minDate={dayjs(mintDate)}
                          maxDate={dayjs(maxDate)}
                          className="w-100"
                          size="large"
                          disabled={!isNew && planPeriodType === PlantPeriodType.Quarter}
                          format={APP_LOCAL_DATE_FORMAT}
                          placeholder="Chọn ngày bắt đầu"
                        />
                      </Form.Item>
                    </Col>
                    <Col md={1} />
                    <Col md={4}>
                      <Form.Item
                        label="Thời hạn hoàn thành"
                        rules={[{ required: true, message: 'Hãy chọn thời hạn hoàn thành' }]}
                        name={'dueDate'}
                      >
                        <DatePicker
                          minDate={dayjs(mintDate)}
                          maxDate={dayjs(maxDate)}
                          className="w-100"
                          size="large"
                          disabled={!isNew && planPeriodType === PlantPeriodType.Quarter}
                          format={APP_LOCAL_DATE_FORMAT}
                          placeholder="Chọn thời hạn hoàn thành"
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                </>
              ))}
            {krTypeValues !== KrTypes.Qualitative ? (
              <Row>
                <Col md={3}>
                  <Form.Item label="Xu hướng" rules={[{ required: true, message: 'Vui lòng chọn xu hướng' }]} name="metricType">
                    <Select
                      filterOption={filterOption}
                      allowClear
                      showSearch
                      size="large"
                      disabled={!isNew && planPeriodType === PlantPeriodType.Quarter}
                      options={krTrendingTypes}
                      placeholder="Chọn xu hướng"
                    />
                  </Form.Item>
                </Col>
                <Col md={1} />
                <Col md={3}>
                  <Form.Item label={`Chỉ tiêu ${planPeriodSelected ? planPeriodSelected.name : ''}`} name={'metricValue'}>
                    <InputNumber
                      disabled={!isNew && planPeriodType === PlantPeriodType.Quarter} className='w-100' formatter={formatNumber} parser={parseNumber} placeholder={`nhập chỉ tiêu ${planPeriodSelected ? planPeriodSelected.name : ''}`} size="large" />
                  </Form.Item>
                </Col>
                <Col md={1} />
                {handleMapperResultByPlanPeriod()}
              </Row>
            ) : null}
            <Row>
              <Col md={3}>
                <Form.Item
                  label="Tần suất báo cáo"
                  rules={[{ required: true, message: 'Hãy chọn tần suất báo cáo' }]}
                  name="frequencyId"
                >
                  <Select
                    filterOption={filterOption}
                    allowClear
                    showSearch
                    size="large"
                    disabled={!isNew && planPeriodType === PlantPeriodType.Quarter}
                    options={frequencies}
                    placeholder="Chọn tần suất báo cáo"
                  />
                </Form.Item>
              </Col>
              <Col md={1} />
              {krTypeValues === KrTypes.Qualitative ? (
                <Col md={6}>
                  <Form.Item
                    label="Cách đánh giá tỷ lệ hoàn thành"
                    rules={[{ required: true, message: 'Hãy chọn cách đánh giá' }]}
                    name="evaluationMethods"
                  >
                    <Checkbox.Group
                      disabled={!isNew && planPeriodType === PlantPeriodType.Quarter} className="d-grid" options={qualityEvaluationTypes} />
                  </Form.Item>
                </Col>
              ) : (
                <>
                  <Col md={5}>
                    <Form.Item
                      label="Cách đánh giá tỷ lệ hoàn thành"
                      rules={[{ required: true, message: 'Hãy chọn cách đánh giá' }]}
                      name="evaluationMethodQuantitative"
                    >
                      <Radio.Group
                        disabled={!isNew && planPeriodType === PlantPeriodType.Quarter} className="d-grid" options={quantitativeTypes} />
                    </Form.Item>
                  </Col>
                  <Col md={1} />
                  <Col md={13} className="mt-4">
                    <Form.Item rules={[{ required: evaluationMethodQuantitativeValue === QuantitativeEvaluationType.SelfDefinition, message: "Vui lòng nhập nội dung định nghĩa" }]} name={'evaluationMethodQuantitativeNote'}>
                      {evaluationMethodQuantitativeValue >= 0 ? (
                        <TextArea
                          rows={1}
                          disabled={(evaluationMethodQuantitativeValue !== QuantitativeEvaluationType.SelfDefinition) || (!isNew && planPeriodType === PlantPeriodType.Quarter)}
                          placeholder="Nhập nội dung định nghĩa"
                          size="large"
                        />
                      ) : undefined}
                    </Form.Item>
                  </Col>
                </>
              )}
            </Row>
            <Row>
              <Col md={7}>
                <Form.Item
                  label="Người thực hiện chính (PIC)"
                  rules={[{ required: true, message: 'Hãy chọn người thực hiện chính' }]}
                  name="accountableId"
                >
                  <Select
                    allowClear
                    showSearch
                    size="large"
                    filterOption={filterOption}
                    options={employeeList.map(x => {
                      return {
                        label: x.name,
                        value: x.id,
                      };
                    })}
                    placeholder="Chọn người thực hiện chính"
                  />
                </Form.Item>
              </Col>
              <Col md={1} />
              <Col md={7}>
                <Form.Item label="Các bên tham gia thực hiện trực tiếp" name="responsibleIds">
                  <Select
                    allowClear
                    showSearch
                    mode="multiple"
                    size="large"
                    disabled={!isNew && planPeriodType === PlantPeriodType.Quarter}
                    filterOption={filterOption}
                    options={employeeList.map(x => {
                      return {
                        label: x.name,
                        value: x.id,
                      };
                    })}
                    placeholder="Chọn các bên tham gia thực hiện trực tiếp"
                  />
                </Form.Item>
              </Col>
              <Col md={1} />
              <Col md={8}>
                <Form.Item label="Các bên hỗ trợ" name="consultantIds">
                  <Select
                    allowClear
                    showSearch
                    mode="multiple"
                    size="large"
                    disabled={!isNew && planPeriodType === PlantPeriodType.Quarter}
                    filterOption={filterOption}
                    options={employeeList.map(x => {
                      return {
                        label: x.name,
                        value: x.id,
                      };
                    })}
                    placeholder="Chọn các bên hỗ trợ"
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col md={7}>
                <Form.Item label="Người nhận thông báo (cách nhau dấu phẩy)" name={'informEmails'}>
                  <TextArea
                    disabled={!isNew && planPeriodType === PlantPeriodType.Quarter} placeholder="Nhập người nhận thông báo" size="large" />
                </Form.Item>
                <Form.Item valuePropName="checked" name={'sendingNotification'}>
                  <Checkbox
                    disabled={!isNew && planPeriodType === PlantPeriodType.Quarter}>Gửi thông báo đến người nhận</Checkbox>
                </Form.Item>
              </Col>
              <Col md={1} />
              <Col md={7}>
                <Form.Item label="Phân quyền truy cập" name={'accessIds'}>
                  <Select
                    filterOption={filterOption}
                    allowClear
                    showSearch
                    mode='multiple'
                    size="large"
                    disabled={!isNew && planPeriodType === PlantPeriodType.Quarter}
                    options={employeeList.map(x => {
                      return {
                        label: x.name,
                        value: x.id,
                      };
                    })}
                  />
                </Form.Item>
              </Col>
              <Col md={1} />
              <Col md={8}>
                <Form.Item label="Tag" name={'tags'}>
                  <TextArea
                    disabled={!isNew && planPeriodType === PlantPeriodType.Quarter} placeholder="Nhập tag" size="large" />
                </Form.Item>
              </Col>
            </Row>
            <Form.Item>
              <Row className="action mt-3" justify="end">
                {isNew && (
                  <Col>
                    <Button className="green" onClick={handleNextKr} disabled={updating}>
                      Lưu & Tạo KR khác
                    </Button>
                  </Col>
                )}
                <Col>
                  <Button
                    className="secondary"
                    disabled={updating}
                    onClick={() => {
                      handleClose();
                    }}
                  >
                    Hủy
                  </Button>
                </Col>
                <Col>
                  <Button className="primary" htmlType="submit" disabled={updating || isReadOnly}>
                    Lưu
                  </Button>
                </Col>
              </Row>
            </Form.Item>
          </Form>
        </Container>
        {isOpenModalFormObjective && (
          <ObjectiveUpdate isOpen={isOpenModalFormObjective} id={id ?? idObjective} onClose={handleCloseModelObjective} />
        )}
        {isOpenModal &&
          <ObjectiveKRRowSelection defaultSelected={[]} isOpen={isOpenModal} onClose={handleCloseModal} />
        }
      </Spin>
    </Modal>
  );
};

export default KRUpdate;
